import * as React from 'react'

type Toast = { id: string; message: string; type?: 'success' | 'error' | 'warning' | 'info'; duration?: number }

type ToastContextValue = {
  push: (message: string | React.ReactNode, type?: Toast['type'], duration?: number) => string
}

export const ToastContext = React.createContext<ToastContextValue | null>(null)

export function useToasts() {
  const ctx = React.useContext(ToastContext)
  if (!ctx) throw new Error('useToasts must be used within <ToastProvider>')
  return ctx
}